import {
  useGetAllocatedSupervisorProjectsQuery,
  useGetSupervisorProjectsSummaryQuery,
} from './api/supervisorProjectsApiSlice';

interface UseSupervisorProjectsScreenResult {
  referenceStandardReviewProjectsCount: number;
  inProgressProjectsCount: number;
  completedProjectsCount: number;
  totalProjectsCount: number;
  isProjectsSummaryLoading: boolean;
  allocatedProjectIds: string[];
  isAllocationProjectsLoading: boolean;
}
export const useSupervisorProjectsScreen = (): UseSupervisorProjectsScreenResult => {
  const {
    data: projectsSummary,
    isLoading: isProjectsSummaryLoading,
    isFetching: isProjectsSummaryFetching,
  } = useGetSupervisorProjectsSummaryQuery();

  const {
    data: allocationProjects,
    isLoading: isAllocationProjectsLoading,
    isFetching: isAllocationProjectsFetching,
  } = useGetAllocatedSupervisorProjectsQuery();

  return {
    referenceStandardReviewProjectsCount:
      projectsSummary?.data?.referenceStandardReviewProjectsCount ?? 0,
    inProgressProjectsCount: projectsSummary?.data?.inProgressProjectsCount ?? 0,
    completedProjectsCount: projectsSummary?.data?.completedProjectsCount ?? 0,
    totalProjectsCount: projectsSummary?.data?.totalProjectsCount ?? 0,
    isProjectsSummaryLoading: isProjectsSummaryLoading || isProjectsSummaryFetching,
    allocatedProjectIds: allocationProjects?.data?.map((prj) => prj.id) || [],
    isAllocationProjectsLoading: isAllocationProjectsFetching || isAllocationProjectsLoading,
  };
};
